import { useState, useRef } from 'react';
import { useClickAway } from 'react-use';
import { Tooltip } from './Tooltip';
import { ToggletipContainer } from './Tooltip.styled';
import { TooltipProps, TipPlacement } from './types';

export const Toggletip = ({ children, open = false, tooltipContent, ...props }: TooltipProps) => {
  const [isOpen, setIsOpen] = useState(open);
  const wrapperRef = useRef(null);

  useClickAway(wrapperRef, () => {
    setIsOpen(false);
  });

  return (
    <ToggletipContainer
      ref={wrapperRef}
      onClick={() => setIsOpen(true)}
      onFocus={() => setIsOpen(true)}
      onBlur={() => setIsOpen(false)}
    >
      <Tooltip open={isOpen} tooltipContent={tooltipContent} {...props}>
        {children}
      </Tooltip>
    </ToggletipContainer>
  );
};

export const TopToggletip = (props: Omit<TooltipProps, 'placement'>) => (
  <Toggletip placement={TipPlacement.Top} {...props} />
);
export const BottomToggletip = (props: Omit<TooltipProps, 'placement'>) => (
  <Toggletip placement={TipPlacement.Bottom} {...props} />
);
export const RightToggletip = (props: Omit<TooltipProps, 'placement'>) => (
  <Toggletip placement={TipPlacement.Right} {...props} />
);
export const LeftToggletip = (props: Omit<TooltipProps, 'placement'>) => (
  <Toggletip placement={TipPlacement.Left} {...props} />
);
